import Icon, { type IconName } from "./Icon";

// Shared empty / error placeholders for API-backed panels.

export function PanelError({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-10 text-center">
      <span
        className="neu-sm grid place-items-center w-13 h-13 p-3.5 rounded-2xl"
        style={{ color: "var(--danger)" }}
      >
        <Icon name="shield" size={20} />
      </span>
      <p className="text-[13.5px] font-medium text-text">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="neu-btn h-9 px-4 rounded-xl text-[12.5px] font-medium text-text-muted"
        >
          Retry
        </button>
      )}
    </div>
  );
}

export function PanelEmpty({
  title,
  hint,
  icon = "search",
}: {
  title: string;
  hint?: string;
  icon?: IconName;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-10 text-center">
      <span className="neu-sm grid place-items-center w-13 h-13 p-3.5 rounded-2xl text-text-faint">
        <Icon name={icon} size={20} />
      </span>
      <p className="text-[13.5px] font-medium text-text">{title}</p>
      {hint && <p className="text-[12.5px] text-text-faint">{hint}</p>}
    </div>
  );
}

/** Renders a dash plus the API's reason when a metric is not yet computable. */
export function Unavailable({ reason }: { reason?: string }) {
  return (
    <span
      className="font-display text-text-faint"
      title={reason ?? "Not reported by the API"}
    >
      —
    </span>
  );
}
